"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlightPassengerListBulkActions = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const legacy_1 = require("../../../../Form/Field/Select/legacy");
const FlightPassengerListBulkActions = (props) => {
    const { markAppeared, markNotAppeared, markPending, disabled, hidden } = props;
    const items = (0, react_1.useMemo)(() => [
        {
            name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/BulkActions:Select', defaultMessage: 'Please select action...' })),
            value: '',
            action: () => { },
        },
        {
            name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/BulkActions:MarkAppeared', defaultMessage: 'Mark as appeared' })),
            value: 'appeared',
            action: markAppeared,
        },
        {
            name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/BulkActions:MarkNotAppeared', defaultMessage: 'Mark as no-show' })),
            value: 'notAppeared',
            action: markNotAppeared,
        },
        {
            name: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Flight/Passenger/List/BulkActions:MarkPending', defaultMessage: 'Mark as pending' })),
            value: 'pending',
            action: markPending,
        },
    ], [markAppeared, markNotAppeared, markPending]);
    const handleSelectChange = (0, react_1.useCallback)((event) => {
        const item = items.find(x => x.value === event.target.value);
        if (!item)
            return;
        item.action();
    }, [items]);
    if (hidden)
        return null;
    return (react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { value: '', onChange: handleSelectChange, items: items, disabled: disabled }));
};
exports.FlightPassengerListBulkActions = FlightPassengerListBulkActions;
//# sourceMappingURL=index.js.map